module.exports = __webpack_public_path__ + "img/cancel-flow-dash-hero.b0cd45e0.svg";